import { render, staticRenderFns } from "./MainAlert.vue?vue&type=template&id=21027242&scoped=true&"
import script from "./MainAlert.vue?vue&type=script&lang=js&"
export * from "./MainAlert.vue?vue&type=script&lang=js&"
import style0 from "./MainAlert.vue?vue&type=style&index=0&id=21027242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21027242",
  null
  
)

export default component.exports